/**
 * Format unread count for display
 * Returns "9+" if count > 10, otherwise returns the count as string
 */
export const formatUnreadCount = (count: number): string => {
  if (count > 10) {
    return "9+";
  }
  return count.toString();
};

